import { type ApiErrorResponseDetails } from '../schema-dtos/ApiResponseDetails'

 
export class RtkQueryHelper {
  static mapResponseError = (error?: any): string => {
    if (Boolean(error?.data) && ((error.data as ApiErrorResponseDetails).clientMessage) !== '') {
      return (error.data as ApiErrorResponseDetails)?.clientMessage
    } else if (typeof error?.status === 'string' && (error.status === 'FETCH_ERROR')) {
      return 'Unable to connect to the site. Please log out and then log back in again. If the issue persists please contact support.'
    } else if (typeof error?.status === 'number' && (error.status === 429)) {
      return 'You have made too many requests. Please try again later.'
    }
    return JSON.stringify(error)
  }
}
